shadow$provide[444] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `void setScreenPosition(vec4 position) {
  gl_Position = vec4(position.xy * 2.0 - 1.0, 0.5, 1.0);
}
`;

};